import * as React from "react"
import { useEffect, useState } from 'react'
import { graphql, Link } from "gatsby"
import { Layout } from "../../../components/layout"
import isEqual from "lodash.isequal"
import { GatsbyImage, getSrc } from "gatsby-plugin-image"
import { StoreContext } from "../../../context/store-context"
import { AddToCart } from "../../../components/add-to-cart"
import { NumericInput } from "../../../components/numeric-input"
import { formatPrice } from "../../../utils/format-price"
import { Seo } from "../../../components/seo"
import { CgChevronRight as ChevronIcon } from "react-icons/cg"
import {
  productBox,
  container,
  header,
  productImageWrapper,
  productImageList,
  productImageListItem,
  scrollForMore,
  noImagePreview,
  optionsWrapper,
  priceValue,
  selectVariant,
  labelFont,
  breadcrumb,
  tagList,
  addToCartStyle,
  metaSection,
  productDescription,
} from "./product-page.module.css"
import { IngredientLibraryHomePageSection, InstagramFeed, TestimonialsHomePageSection } from "../../../components/homepageComponents"
import SkinCorrectingBlock from "../../../components/block-skin-correcting"
import { styled } from '../../../styles/stitches.config';
import OptimiseRoutineSection from "../../../components/product/optimise-routine"

export default function Product({ data: { product, suggestions } }) {
  const [delivery, setDelivery] = useState('');
  useEffect(() => {
    document.getElementsByTagName('body')[0].style.overflow = "auto";
    fetch("https://v1.nocodeapi.com/mrkuok/google_sheets/PWjtIPEhWKqmOHPT?tabId=Sheet1").then(
      data => data.json()
    ).then(result => {
      if (JSON.parse(result.data[0].preorderStatus.toLowerCase())) {
        setDelivery(result.data[0].copy);
        setPreorderStatus(JSON.parse(result.data[0].preorderStatus.toLowerCase()));
      }
      // setPreorderStatus(result.data[0].preorderStatus);
    });
  }, []);
  const ProductDetailsContainer = styled('div', {
    '@bp4': {
      paddingTop: '40px',
      paddingLeft: '80px',
      paddingRight: '80px',
    },
    h1: {
      fontFamily: '$default',
      fontWeight: 500,
      fontSize: '40px',
      letterSpacing: '1px',
      marginBottom: '12px',
      lineHeight: '44px',
    },
    h2: {
      margin: '0px',
      fontFamily: '$default',
      color: '#666',
    },
    h3: {
      fontFamily: '$default',
      textTransform: 'uppercase',
      fontWeight: 600,
      fontSize: '18px',
      margin: '40px 0 20px 0',
      letterSpacing: '2px',
    },
    p: {
      fontFamily: '$lato',
      fontSize: '18px',
      lineHeight: '29px',
      margin: '0 0 20px 0',
    },
    '& .extraInfo': {
      margin: '20px 0px',
      fontFamily: '$default',
      color: '#666',
      fontSize: '16px',
    },
  });

  const StyledAddToCart = styled(AddToCart, {
    fontFamily: '$lato',
    color: 'white',
    padding: '14px 40px',
    backgroundColor: 'black',
    textTransform: 'uppercase',
    '@bp1': {
      fontSize: '12px',
    },
  });

  const QuickLink = styled('a', {
    cursor: 'pointer',
    display: 'inline-block',
    textTransform: 'uppercase',
    color: '#1a1a1a',
    letterSpacing: '4px',
    fontSize: '14px',
    fontFamily: '$lato',
    paddingBottom: '4px',
    borderBottom: '1px solid #1a1a1a',
    '&:hover': {
      opacity: 0.8,
    },
  });

  const {
    options,
    variants,
    variants: [initialVariant],
    priceRangeV2,
    id,
    title,
    description,
    images,
    images: [firstImage],
  } = product
  const { client } = React.useContext(StoreContext)

  const [variant, setVariant] = React.useState({ ...initialVariant })
  const [quantity, setQuantity] = React.useState(1)

  const productVariant =
    client.product.helpers.variantForOptions(product, variant) || variant

  const [available, setAvailable] = React.useState(
    productVariant.availableForSale
  )

  const [preorderStatus, setPreorderStatus] = React.useState(
    false
  )

  const checkAvailablity = React.useCallback(
    (productId) => {
      client.product.fetch(productId).then((fetchedProduct) => {
        console.log(fetchedProduct);
        console.log(productVariant.storefrontId);
        const result =
          fetchedProduct?.variants.filter(
            (variant) => variant.id === atob(productVariant.storefrontId)
          ) ?? []

        if (result.length > 0) {
          // console.log(result[0]);
          setAvailable(result[0].available)
        }
      })
    },
    [productVariant.storefrontId, client.product]
  )

  const handleOptionChange = (index, event) => {
    const value = event.target.value

    if (value === "") {
      return
    }

    const currentOptions = [...variant.selectedOptions]

    currentOptions[index] = {
      ...currentOptions[index],
      value,
    }

    const selectedVariant = variants.find((variant) => {
      return isEqual(currentOptions, variant.selectedOptions)
    })

    setVariant({ ...selectedVariant })
  }

  React.useEffect(() => {
    checkAvailablity(product.storefrontId);
    console.log(available);
  }, [productVariant.storefrontId, checkAvailablity, product.storefrontId])

  // React.useEffect(() => {
  //   console.log(id);
  // }, [])

  const price = formatPrice(
    priceRangeV2.minVariantPrice.currencyCode,
    variant.price
  )

  const hasVariants = variants.length > 1
  const hasImages = images.length > 0
  const hasMultipleImages = true || images.length > 1

  return (
    <Layout>
      {firstImage ? (
        <Seo
          title={title + ' - Better Days Skin Co.'}
          description={description}
          image={getSrc(firstImage.gatsbyImageData)}
        />
      ) : undefined}
      <div className={container} style={{ backgroundColor: '#f3eee7' }}>
        <ProductDetailsContainer className={productBox}>
          {hasImages && (
            <div className={productImageWrapper}>
              <div
                role="group"
                aria-label="gallery"
                aria-describedby="instructions"
              >
                <ul className={productImageList}>
                  {images.map((image, index) => (
                    <li
                      key={`product-image-${image.id}`}
                      className={productImageListItem}
                    >
                      <GatsbyImage
                        objectFit="contain"
                        loading={index === 0 ? "eager" : "lazy"}
                        alt={
                          image.altText
                            ? image.altText
                            : `Product Image of ${title} #${index + 1}`
                        }
                        image={image.gatsbyImageData}
                      />
                    </li>
                  ))}
                </ul>
              </div>
              {hasMultipleImages && (
                <div className={scrollForMore} id="instructions">
                  <span aria-hidden="true">←</span> scroll for more{" "}
                  <span aria-hidden="true">→</span>
                </div>
              )}
            </div>
          )}
          {!hasImages && (
            <span className={noImagePreview}>No Preview image</span>
          )}
          <div>
            {/* <div className={breadcrumb}>
              <Link to={product.productTypeSlug}>{product.productType}</Link>
              <ChevronIcon size={12} />
            </div> */}
            <h1 className={header}>{title}</h1>
            <h2>
              <span>{price}</span>
            </h2>
            <fieldset className={optionsWrapper}>
              {hasVariants &&
                options.map(({ id, name, values }, index) => (
                  <div className={selectVariant} key={id}>
                    <select
                      aria-label="Variants"
                      onChange={(event) => handleOptionChange(index, event)}
                    >
                      <option value="">{`Select ${name}`}</option>
                      {values.map((value) => (
                        <option value={value} key={`${name}-${value}`}>
                          {value}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
            </fieldset>
            <div className={addToCartStyle}>
              <NumericInput
                aria-label="Quantity"
                onIncrement={() => setQuantity((q) => Math.min(q + 1, 20))}
                onDecrement={() => setQuantity((q) => Math.max(1, q - 1))}
                onChange={(event) => setQuantity(event.currentTarget.value)}
                value={quantity}
                min="1"
                max="20"
              />
              <StyledAddToCart
                variantId={productVariant.storefrontId}
                quantity={quantity}
                available={available}
                preorderStatus={preorderStatus}
              />
            </div>
            {/* <p className="extraInfo">All prices in SGD. Pre-orders will start shipping early-June 2021. All repeat orders will ship with minimal packaging unless requested otherwise.</p> */}
            {id == "bdd71a41-42d4-50f6-9fd0-7e1f2075448f" ?
              <p className="extraInfo">All prices in SGD. {delivery} All repeat orders will ship with minimal packaging unless requested otherwise.</p>
              // <p className="extraInfo">All prices in SGD. The December 2021 allocation is now sold out! Pre-orders of our gift set will start shipping late-Jan 2022.</p>
              :
              <span></span>
            }
            {id == "c1dcfe94-cb66-551e-8333-b1cf74a3cf0a" ?
              <p className="extraInfo">All prices in SGD.</p>
              // <p className="extraInfo">All prices in SGD. The December 2021 allocation is now sold out! Pre-orders of our gift set will start shipping late-Jan 2022.</p>
              :
              <span></span>
            }
            {id == "af0bb3aa-58e8-5636-a219-03e448709180" ?
              <p className="extraInfo">All prices in SGD.</p>
              // <p className="extraInfo">All prices in SGD. The December 2021 allocation is now sold out! Pre-orders of our gift set will start shipping late-Jan 2022.</p>
              :
              <span></span>
            }
            {/* {id == "af0bb3aa-58e8-5636-a219-03e448709180" ?
              <p className="extraInfo">All prices in SGD. The December 2021 allocation is now sold out! Pre-orders of our gift set will start shipping late-Jan 2022.</p>
              :
              <p className="extraInfo">All prices in SGD. Pre-orders will start shipping late-Jan 2022. All repeat orders will ship with minimal packaging unless requested otherwise.</p>
            } */}
            {/* <p className={productDescription}>{description}</p> */}
            <h3>Description</h3>
            {id == "bdd71a41-42d4-50f6-9fd0-7e1f2075448f" ?
              <>
                <p>A category-defining multi-tasker that is exceptionally gentle with long-lasting results.</p>
                <p>The light milky essence is formulated with a blend of proven actives, skin identical elements, nourishing antioxidants and plant-based Traditional Chinese Medicine extracts that work in synergy for soft, creamy, healthy skin. The complex formula is designed to simplify your routine by providing 7 skin-correcting benefits in one gentle step: renew, hydrate, brighten, firm, energise, soothe and restore. Skin is visibly improved with a smoother, brighter, more balanced complexion.</p>
                <p>Formulated without any added fragrance, artificial colouring, parabens, and mineral oil.</p>
                <QuickLink href='#skinCorrectingBlock' onClick={() => window.location.replace("#skinCorrectingBlock")}>7 Skin Correcting Benefits</QuickLink>
                <h3>Application</h3>
                <p>Apply morning and/or night-time as desired. After cleansing, smooth a few drops onto your face, followed by your moisturiser.</p>
                <p>For daytime use, always finish with sunscreen rated SPF 30 or greater.</p>
                <p><b>NOTE:</b> For external use only, avoid contact with eyes.</p>
                <QuickLink href='#optimiseYourRoutine' onClick={() => window.location.replace("#optimiseYourRoutine")}>Optimise Your Routine</QuickLink>
                <h3>Ingredients</h3>
                <p><b>1.5% Salicylic Acid, 1% L-Lactic Acid, 4% Niacinamide and 2% CoQ10:</b></p>
                <p>Superstar active ingredients gently exfoliate and renew skin cells, refine and unclog pores, brighten and even skin tone, fade discolouration, activate cellular energy, boost natural collagen production and improve elasticity.</p>
                <p><b>Ceramides and Amino Acids:</b></p>
                <p>Essential elements of skin structure replenish and firm skin, maintain and restore skin barrier to improve moisture retention and prevent future skin issues.</p>
                <p><b>Aloe Vera, Glycerin, Allantoin, Sodium Hyaluronate, Jojoba Oil:</b></p>
                <p>Healing ingredients work together to provide multi-level hydration, stimulate new skin tissue, soothe and repair skin, restore comfort and suppleness.</p>
                <p><b>Chamomile, Green Tea, Korean Red Ginseng, Japanese Knotweed, Ginkgo Biloba, Grape Seed Oil:</b></p>
                <p>Potent plant-based antioxidants and Traditional Chinese Medicine extracts deliver vitamins and nutrients, moisturise and calm skin irritation, and defend against environmental damage.</p>
                <p><b>NOTE:</b> Please store your bottle away from sunlight.</p>
                <p><b>Full Ingredients:</b> Aqua, Chamomile Recutita Flower Extract, Niacinamide (Vitamin B3), Ubiquinone (CoQ10), Camellia Sinensis (Green Tea) Leaf Extract, Aloe Vera Juice Liquid Extract, Vitis Vinifera (Grape) Seed Oil, Simmondsia Chinensis (Jojoba) Seed Oil, Sodium PCA, Sodium Lactate, Arginine, Aspartic Acid, PCA, Glycine, Alanine, Serine, Valine, Proline, Threonine, Isoleucine, Histidine, Phenylalanine, Ceramides, Salicylic Acid, L-Lactic Acid, Glycerin, Polugonum Cuspidatum (Japanese Knotweed) Root Extract, Red Panax Ginseng Extract, Sodium Hyaluronate, Butylene Glycol, Xanthan Gum, Allantoin, Ginkgo Biloba Leaf Extract.</p>
                <p>Due to the BHA (salicylic acid) content, please consult your doctor if pregnant / breastfeeding.</p>
              </>
              :
              <></>
            }
            {id == "c1dcfe94-cb66-551e-8333-b1cf74a3cf0a" ?
              <>
                <p>Dreams do come true. You asked for it and we made it happen. Our black and white Gua Sha &amp; Roller set feels cool and soothing on your skin. These Traditional Chinese Medicine tools help reduce tension and puffiness while boosting microcirculation for a healthy glow.</p>
                <p>Our limited edition set includes:</p>
                <p>
                  <ul style={{ marginLeft: '20px' }}>
                    <li>White Quartz Roller x 1</li>
                    <li>Black Obsidian Gua Sha x 1</li>
                    <li>Better Days x Moon Convos drawstring pouch x 1</li>
                  </ul>
                </p>
                <p>Please clean and disinfect your tools properly before usage. We recommend using the tools with a facial oil, or with a sheet mask (our preferred method!). You can check out our &quot;Gua &amp; Roll + Sheet mask tutorial&quot; video on Instagram.</p>
              </>
              :
              <></>
            }
            {id == "af0bb3aa-58e8-5636-a219-03e448709180" ?
              <>
                <p>Our gift set is enveloped in a dreamy watercolour painting that reflects the misty morning colours of Jackson, Wyoming. In it, you&apos;ll find everything you need to create your own spa ritual at home.</p>
                <p>What it includes:</p>
                <p>
                  <ul style={{ marginLeft: '20px' }}>
                    <li>Multi-Active Treatment Essence 35ml</li>
                    <li>Embroidered Better Days Skin Co. terry cloth zip pouch</li>
                    <li>Reusable organic cotton bamboo rounds x 10 with laundry mesh bag</li>
                    <li>Better Days Skin Co. hand soap, handcrafted by Roughbeauty co.</li>
                  </ul>
                </p>
                <h3>Ingredients</h3>
                <p>MULTI-ACTIVE TREATMENT ESSENCE</p>
                <p>Aqua, Chamomile Recutita Flower Extract, Niacinamide (Vitamin B3), Ubiquinone (CoQ10), Camellia Sinensis (Green Tea) Leaf Extract, Aloe Vera Juice Liquid Extract, Vitis Vinifera (Grape) Seed Oil, Simmondsia Chinensis (Jojoba) Seed Oil, Sodium PCA, Sodium Lactate, Arginine, Aspartic Acid, PCA, Glycine, Alanine, Serine, Valine, Proline, Threonine, Isoleucine, Histidine, Phenylalanine, Ceramides, Salicylic Acid, L-Lactic Acid, Glycerin, Polugonum Cuspidatum (Japanese Knotweed) Root Extract, Red Panax Ginseng Extract, Sodium Hyaluronate, Butylene Glycol, Xanthan Gum, Allantoin, Ginkgo Biloba Leaf Extract.</p>
                <p>CHAMOMILE HAND SOAP</p>
                <p>Saponified oils (Coconut, rice bran, sustainable palm &amp; castor), Rosemary essential oil, Geranium essential oil, Chamomile flowers.</p>
                <h3>How To Use</h3>
                <p>REUSABLE ORGANIC COTTON BAMBOO ROUNDS</p>
                <p>Place the used rounds in the provided laundry mesh bag for washing. Use gentle soap and lay flat to dry.</p>
              </>
              :
              <></>
            }
            {/* <div className={metaSection}>
              <span className={labelFont}>Type</span>
              <span className={tagList}>
                <Link to={product.productTypeSlug}>{product.productType}</Link>
              </span>
              <span className={labelFont}>Tags</span>
              <span className={tagList}>
                {product.tags.map((tag) => (
                  <Link to={`/search?t=${tag}`}>{tag}</Link>
                ))}
              </span>
            </div> */}
          </div>
        </ProductDetailsContainer>
      </div>
      {id == "af0bb3aa-58e8-5636-a219-03e448709180" || id == "c1dcfe94-cb66-551e-8333-b1cf74a3cf0a" ?
        ''
        :
        <>
          <TestimonialsHomePageSection />
          <SkinCorrectingBlock id="skinCorrectingBlock" />
          <OptimiseRoutineSection id="optimiseYourRoutine" />
          <IngredientLibraryHomePageSection showButton={true} />
        </>
      }
      <InstagramFeed />
    </Layout >
  )
}

export const query = graphql`
  query($id: String!, $productType: String!) {
    product: shopifyProduct(id: { eq: $id }) {
      title
      id
      description
      productType
      productTypeSlug: gatsbyPath(
        filePath: "/products/{ShopifyProduct.productType}"
      )
      tags
      priceRangeV2 {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      storefrontId
      images {
        # altText
        id
        gatsbyImageData(layout: CONSTRAINED, width: 640, aspectRatio: 1)
      }
      variants {
        availableForSale
        storefrontId
        title
        price
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
        id
      }
    }
    suggestions: allShopifyProduct(
      limit: 3
      filter: { productType: { eq: $productType }, id: { ne: $id } }
    ) {
      nodes {
        ...ProductCard
      }
    }
  }
`
